import { render, staticRenderFns } from "./TabsChattingNoData.vue?vue&type=template&id=4eb0edac&scoped=true&"
import script from "./TabsChattingNoData.vue?vue&type=script&lang=js&"
export * from "./TabsChattingNoData.vue?vue&type=script&lang=js&"
import style0 from "./TabsChattingNoData.vue?vue&type=style&index=0&id=4eb0edac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb0edac",
  null
  
)

export default component.exports